import svg4everybody from 'svg4everybody';

export default function() {
    svg4everybody();


    function toKlaviyoItems(items) {
        let out = [];
        items.forEach((i) => {
            out.push({
                "ProductID": i.id,
                 "SKU": i.id,
                 "ProductName": i.name,
                 "Quantity": i.quantity,
                 "ItemPrice": i.unitPrice,
                 "RowTotal": i.totalPrice,
                 "ProductURL": i.url,
                 "ImageURL": i.image,
                 "ProductCategories": i.categories && i.categories.length ? i.categories : []
            })
        })
        return out;
    }

    if (!window.snipcartEventsRegistered) {
        window.snipcartEventsRegistered = true;
        window._learnq = window._learnq || [];
        Snipcart.events.on('item.added', (cartItem) => {
            setTimeout(() => {
                let trackedItem = ["track", "Added to Cart", {
                    "$value": Snipcart.store.getState().cart.subtotal,
                    "AddedItemProductName": cartItem.name,
                    "AddedItemProductID": cartItem.id,
                    "AddedItemCategories": cartItem.categories,
                    "AddedItemImageURL": cartItem.image,
                    "AddedItemURL": cartItem.url,
                    "AddedItemPrice": cartItem.price,
                    "AddedItemQuantity": cartItem.quantity,
                    "ItemNames": Snipcart.store.getState().cart.items.items.map((i) => { return i.name }),
                    "CheckoutURL": "https://www.randolph.ca/#/checkout",
                    "Items": toKlaviyoItems(Snipcart.store.getState().cart.items.items)
                }];
                console.log(trackedItem);
                window._learnq.push(trackedItem);
            },500);
        });
        Snipcart.events.on('item.updated', (cartItem) => {
            setTimeout(() => {
                let trackedItem = ["track", "Cart Item Updated", {
                    "$value": Snipcart.store.getState().cart.subtotal,
                    "UpdatedItemProductName": cartItem.name,
                    "UpdatedItemProductID": cartItem.id,
                    "UpdatedItemCategories": cartItem.categories,
                    "UpdatedItemImageURL": cartItem.image,
                    "UpdatedItemURL": cartItem.url,
                    "UpdatedItemPrice": cartItem.price,
                    "UpdatedItemQuantity": cartItem.quantity,
                    "ItemNames": Snipcart.store.getState().cart.items.items.map((i) => { return i.name }),
                    "CheckoutURL": "https://www.randolph.ca/#/checkout",
                    "Items": toKlaviyoItems(Snipcart.store.getState().cart.items.items)
                }];
                console.log(trackedItem);
                window._learnq.push(trackedItem);
            },500);
        });
        Snipcart.events.on('item.removed', (cartItem) => {
            setTimeout(() => {
                let trackedItem = ["track", "Cart Item Removed", {
                    "$value": Snipcart.store.getState().cart.subtotal,
                    "RemovedItemProductName": cartItem.name,
                    "RemovedItemProductID": cartItem.id,
                    "RemovedItemCategories": cartItem.categories,
                    "RemovedItemImageURL": cartItem.image,
                    "RemovedItemURL": cartItem.url,
                    "RemovedItemPrice": cartItem.price,
                    "RemovedItemQuantity": cartItem.quantity,
                    "ItemNames": Snipcart.store.getState().cart.items.items.map((i) => { return i.name }),
                    "CheckoutURL": "https://www.randolph.ca/#/checkout",
                    "Items": toKlaviyoItems(Snipcart.store.getState().cart.items.items)
                }];
                console.log(trackedItem);
                window._learnq.push(trackedItem);
            },500);
        });
        Snipcart.events.on('customer.registered', (customer) => {
            window._learnq.push(['identify', {
                '$email' : customer.email
            }]);
        });
        Snipcart.events.on('customer.signedin', (customer) => {
            window._learnq.push(['identify', {
                '$email' : customer.email
            }]);
        });

        // Check when checkout is clicked, if email exists, if yes, track the event.
        Snipcart.events.on('summary.checkout_clicked', () => {
            // Find email
            let email;
            try {
                email = Snipcart.store.getState().cart.email
            } catch(e) {}

            if (email) {
                window._learnq.push(['identify', {
                    '$email' : email
                }]);
            }

            let categories = [];
            Snipcart.store.getState().cart.items.items.forEach((i) => {
                if (i.categories && i.categories.length) categories = categories.concat(i.categories)
            })

            categories = [...new Set(categories)]
            // Example of URL : https://www.rienneseperd.com/?snip-cart-id=5b93eae5-54cf-4ad6-b41b-c3ed2743597a#/checkout
            // Snipcart ID : Snipcart.store.getState().cart.token
            // Send Track for checkout started
            let cartURL = "https://www.randolph.ca/?snip-cart-id="+Snipcart.store.getState().cart.token+'#/checkout';
            _learnq.push(["track", "Started Checkout", {
                "$event_id": Snipcart.store.getState().cart.token+"_"+(new Date().getTime()),
                "$value": Snipcart.store.getState().cart.subtotal,
                "ItemNames": Snipcart.store.getState().cart.items.items.map((o) => { return o.name }),
                "CheckoutURL": cartURL,
                "Categories": categories,
                "Items": toKlaviyoItems(Snipcart.store.getState().cart.items.items)
            }]);

        });

        // At this moment, the email & name are available, send them to Klaviyo
        // Also send as "Checkout Started" there..
        Snipcart.events.on('shipping.selected', () => {
            // Find email
            let email;
            try {
                email = Snipcart.store.getState().cart.email
            } catch(e) {}

            if (email) {
                window._learnq.push(['identify', {
                    '$email' : email
                }]);
            }

            let categories = [];
            Snipcart.store.getState().cart.items.items.forEach((i) => {
                if (i.categories && i.categories.length) categories = categories.concat(i.categories)
            })

            categories = [...new Set(categories)]
            // Example of URL : https://www.rienneseperd.com/?snip-cart-id=5b93eae5-54cf-4ad6-b41b-c3ed2743597a#/checkout
            // Snipcart ID : Snipcart.store.getState().cart.token
            // Send Track for checkout started
            let cartURL = "https://www.randolph.ca/?snip-cart-id="+Snipcart.store.getState().cart.token+'#/checkout';
            _learnq.push(["track", "Started Checkout", {
                "$event_id": Snipcart.store.getState().cart.token+"_"+(new Date().getTime()),
                "$value": Snipcart.store.getState().cart.subtotal,
                "ItemNames": Snipcart.store.getState().cart.items.items.map((o) => { return o.name }),
                "CheckoutURL": cartURL,
                "Categories": categories,
                "Items": toKlaviyoItems(Snipcart.store.getState().cart.items.items)
            }]);

        });

        setTimeout(() => {
            let email;
            try {
                email = Snipcart.store.getState().cart.email
            } catch(e) {}

            if (email) {
                window._learnq.push(['identify', {
                    '$email' : email
                }]);
            }
        },1000);
    }
}
